/* eslint-disable */
export default {
  forward: 'Reenc.',
  reply: 'Responder',
  ignore: 'Ignorar',
  toVoicemail: 'Para correio de voz',
  answer: 'Atender',
  answerAndEnd: 'Atender e terminar',
  answerAndHold: 'Atender e em espera',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
